import React from "react";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import { Link } from "react-router-dom";
import { useGetCmsQuery } from "../../services/auth";
import { PageHero, LoadingState, ErrorState, EmptyState } from "./PublicShared";
import "./PublicPages.scss";

export default function PrivacyPolicy() {
  const { data: cmsData, isLoading, isError, refetch } = useGetCmsQuery();

  const privacyPolicyContent = cmsData?.data?.privacy_policy?.trim();
  const updatedAt = cmsData?.data?.updated_at;

  return (
    <div className="public_page_container">
      <PageHero
        badge="Legal & Privacy"
        badgeIcon={<SecurityOutlinedIcon />}
        title="Privacy Policy"
        subtitle="Learn how It's My Wall collects, uses, and safeguards your personal information and digital assets."
        updatedAt={updatedAt}
      />

      <div className="public_card_container">
        {isLoading ? (
          <LoadingState lines={8} />
        ) : isError ? (
          <ErrorState
            title="Unable to load Privacy Policy"
            message="We were unable to fetch the privacy policy from the server. Please check your network connection and try again."
            onRetry={refetch}
          />
        ) : !privacyPolicyContent ? (
          <EmptyState
            title="No Privacy Policy Published"
            message="The privacy policy is currently being updated by our legal team. Please check back shortly or reach out to support."
          />
        ) : (
          <>
            <div
              className="public_doc_body"
              dangerouslySetInnerHTML={{ __html: privacyPolicyContent }}
            />

            <div className="faq_support_cta" style={{ marginTop: 36 }}>
              <div className="cta_text">
                <h4>Questions about your privacy or data?</h4>
                <p>
                  Our team is dedicated to safeguarding your personal data and digital wall designs.
                </p>
              </div>
              <Link to="/public/support" className="cta_btn">
                Contact Privacy Team
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
